<template>
  <b-container id="app">
    <b-card>
      <SearchBar @SearchKeyRT="searchObj = $event" />
      <hr />
      <FileList :itemsArg="results" />
    </b-card>
  </b-container>
</template>

<script>
import SearchBar from "./components/SearchBar.vue";
import FileList from "./components/FileList.vue";
import $SP from "sharepointplus";

//fields:"Name_x0020_of_x0020_Route,Road_x0020_Type,County_x0020_Name,Change_x0020_One/Description,Change_x0020_Two,Change_x0020_Three,Change_x0020_Four,Change_x0020_Five,Id",

export default {
  name: "App",
  components: {
    SearchBar,
    FileList,
  },
  data: function () {
    return {
      searchObj: {},
      results: [],
      webAbsoluteUrl: window["_spPageContextInfo"].webAbsoluteUrl,
    };
  },
  methods: {
    getInitialState(roadType, keyword) {
      const ctl = this;
      ctl.results = [];
      let strWhere = "";
      if (roadType || keyword) {
        if (roadType && keyword) {
          strWhere =
            "Road_x0020_Type = '" +
            roadType +
            "' AND (Name_x0020_of_x0020_Route LIKE '" +
            keyword +
            "' OR County_x0020_Name LIKE '" +
            keyword +
            "')";
        } else if (roadType) {
          strWhere = "Road_x0020_Type = '" + roadType + "'";
        } else {
          //keyword
          strWhere =
            "Name_x0020_of_x0020_Route LIKE '" +
            keyword +
            "' OR County_x0020_Name LIKE '" +
            keyword +
            "'";
        }
      }
      try {
        $SP()
          .list("Route Changes")
          .get({
            fields:
              "Name_x0020_of_x0020_Route,Road_x0020_Type,County_x0020_Name,Change_x0020_One,Change_x0020_Two,Change_x0020_Three,Change_x0020_Four,Change_x0020_Five,Id",
            rowlimit: 100,
            where: strWhere,
          })
          .then(function (data) {
            data.map(function (item) {
              var objFiles = (function (item) {
                let ListofFiles = [];
                var objFiles = [
                  "Change_x0020_One",
                  "Change_x0020_Two",
                  "Change_x0020_Three",
                  "Change_x0020_Four",
                  "Change_x0020_Five",
                ];
                objFiles.forEach(function (file) {
                  if (item.getAttribute(file)) {
                    ListofFiles.push({
                      ChangeItem: item.getAttribute(file)
                        ? item.getAttribute(file).split(",")[1]
                        : "",
                      ChangeURL: item.getAttribute(file)
                        ? item.getAttribute(file).split(",")[0]
                        : "",
                    });
                  }
                });
                return ListofFiles;
              })(item);
              ctl.results.push({
                Name: item.getAttribute("Name_x0020_of_x0020_Route"),
                "Road Type": item.getAttribute("Road_x0020_Type"),
                County: item.getAttribute("County_x0020_Name"),
                Files: objFiles,
              });
            });
          });

        //this.results = data.data.d.results;
        //If there is a roadType or Keyword we search against the internal files
        if (roadType || keyword) {
          let where = "";

          if (roadType && keyword) {
            where =
              "Route_x0020_Change_x0020_Road_x0020_Type = '" +
              roadType +
              "' AND (Route_x0020_Name LIKE '" +
              keyword +
              "' OR Route_x0020_County LIKE '" +
              keyword +
              "' OR Route_x0020_Number LIKE '" +
              keyword +
              "')";
          } else if (roadType) {
            where =
              "Route_x0020_Change_x0020_Road_x0020_Type = '" + roadType + "'";
          } else {
            //keyword
            where =
              "Route_x0020_Name LIKE '" +
              keyword +
              "' OR Route_x0020_County LIKE '" +
              keyword +
              "' OR Route_x0020_Number LIKE '" +
              keyword +
              "'";
          }
          //////
          ///STAGING ROUTES
          /////
          $SP()
            .list("Staging Route Changes")
            .get({
              fields:
                "Route_x0020_Name,Route_x0020_County,Route_x0020_Change_x0020_Road_x0020_Type,FileRef,FSObjType,BaseName",
              rowlimit: 100,
              where: where,
              folderOptions: {
                show: "FilesandFolders_Recursive",
              },
            })
            .then(function (data) {
              data.map(function (item) {
                if (
                  item.getAttribute("HTML_x0020_File_x0020_Type") ==
                  "SharePoint.DocumentSet"
                ) {
                  //Since our county column is a multi select we need to split it and add duplicate results as well as the files
                  if (
                    item.getAttribute("Route_x0020_County").split("#").length >
                    2
                  ) {
                    item
                      .getAttribute("Route_x0020_County")
                      .split("#")
                      .forEach(function (county) {
                        if (isNaN(county.replace(";", ""))) {
                          console.log(county.replace(";", ""));
                          ctl.results.push({
                            Name: item.getAttribute("Route_x0020_Name"),
                            "Road Type": item.getAttribute(
                              "Route_x0020_Change_x0020_Road_x0020_Type"
                            ),
                            County: county.replace(";", ""),
                            FileRef: item.getAttribute("FileRef").split("#")[1],
                            Files: [],
                          });
                        }
                      });
                  } else {
                    ctl.results.push({
                      Name: item.getAttribute("Route_x0020_Name"),
                      "Road Type": item.getAttribute(
                        "Route_x0020_Change_x0020_Road_x0020_Type"
                      ),
                      County: item
                        .getAttribute("Route_x0020_County")
                        .split("#")[1],
                      FileRef: item.getAttribute("FileRef").split("#")[1],
                      Files: [],
                    });
                  }
                } else {
                  //We need to repeat the same process as the Document Set but we need to find the parent and add the file to the parent
                  //and we need to modify the findIndex so we include also the County as part of the search

                  //Find Element
                  //Find the parent of the current file which is a Document Set
                  if (
                    item.getAttribute("Route_x0020_County").split("#").length >
                    2
                  ) {
                    item
                      .getAttribute("Route_x0020_County")
                      .split("#")
                      .forEach(function (county) {
                        if (isNaN(county.replace(";", ""))) {
                          let filereDocSet = item
                            .getAttribute("FileRef")
                            .split("#")[1];
                          const FileLeafRef = item
                            .getAttribute("FileLeafRef")
                            .split("#")[1];
                          const newFileRefUrl = filereDocSet.substr(
                            0,
                            filereDocSet.indexOf("/" + FileLeafRef)
                          );

                          const objElementIndex = ctl.results.findIndex(
                            (el) =>
                              el.FileRef == newFileRefUrl &&
                              el.County == county.replace(";", "")
                          );

                          //Create a copy of the state
                          let newArray = [...ctl.results];
                          let newFilesArray = [
                            ...newArray[objElementIndex].Files,
                          ];
                          newFilesArray.push({
                            ChangeItem: item.getAttribute("BaseName"),
                            ChangeURL:
                              "/" + item.getAttribute("FileRef").split("#")[1],
                          });
                          //Update one Value
                          newArray[objElementIndex] = {
                            ...newArray[objElementIndex],
                            Files: newFilesArray,
                          };
                          //SetState
                          //ctl.results = ctl.mergeResults(newArray);
                          ctl.results = newArray;
                        }
                      });
                  } else {
                    let filereDocSet = item
                      .getAttribute("FileRef")
                      .split("#")[1];
                    const FileLeafRef = item
                      .getAttribute("FileLeafRef")
                      .split("#")[1];
                    const newFileRefUrl = filereDocSet.substr(
                      0,
                      filereDocSet.indexOf("/" + FileLeafRef)
                    );

                    const objElementIndex = ctl.results.findIndex(
                      (el) => el.FileRef == newFileRefUrl
                    );

                    //Create a copy of the state
                    let newArray = [...ctl.results];
                    let newFilesArray = [...newArray[objElementIndex].Files];
                    newFilesArray.push({
                      ChangeItem: item.getAttribute("BaseName"),
                      ChangeURL:
                        "/" + item.getAttribute("FileRef").split("#")[1],
                    });
                    //Update one Value
                    newArray[objElementIndex] = {
                      ...newArray[objElementIndex],
                      Files: newFilesArray,
                    };
                    //SetState
                    //ctl.results = ctl.mergeResults(newArray);
                    ctl.results = newArray;
                  }
                }
              });
              ctl.results = ctl.mergeResults([...ctl.results]);
            });

          //////
          //Route Numbers
          ////
          $SP()
            .list("Staging Route Numbers")
            .get({
              fields:
                "Route_x0020_Name,Route_x0020_County,Route_x0020_Change_x0020_Road_x0020_Type,FileRef,FSObjType,BaseName",
              rowlimit: 100,
              where: where,
              folderOptions: {
                show: "FilesandFolders_Recursive",
              },
            })
            .then(function (data) {
              data.map(function (item) {
                if (
                  item.getAttribute("HTML_x0020_File_x0020_Type") ==
                  "SharePoint.DocumentSet"
                ) {
                  //Since our county column is a multi select we need to split it and add duplicate results as well as the files
                  if (
                    item.getAttribute("Route_x0020_County").split("#").length >
                    2
                  ) {
                    item
                      .getAttribute("Route_x0020_County")
                      .split("#")
                      .forEach(function (county) {
                        if (isNaN(county.replace(";", ""))) {
                          console.log(county.replace(";", ""));
                          ctl.results.push({
                            Name: item.getAttribute("Route_x0020_Name"),
                            "Road Type": item.getAttribute(
                              "Route_x0020_Change_x0020_Road_x0020_Type"
                            ),
                            County: county.replace(";", ""),
                            FileRef: item.getAttribute("FileRef").split("#")[1],
                            Files: [],
                          });
                        }
                      });
                  } else {
                    ctl.results.push({
                      Name: item.getAttribute("Route_x0020_Name"),
                      "Road Type": item.getAttribute(
                        "Route_x0020_Change_x0020_Road_x0020_Type"
                      ),
                      County: item
                        .getAttribute("Route_x0020_County")
                        .split("#")[1],
                      FileRef: item.getAttribute("FileRef").split("#")[1],
                      Files: [],
                    });
                  }
                } else {
                  //We need to repeat the same process as the Document Set but we need to find the parent and add the file to the parent
                  //and we need to modify the findIndex so we include also the County as part of the search

                  //Find Element
                  //Find the parent of the current file which is a Document Set
                  if (
                    item.getAttribute("Route_x0020_County").split("#").length >
                    2
                  ) {
                    item
                      .getAttribute("Route_x0020_County")
                      .split("#")
                      .forEach(function (county) {
                        if (isNaN(county.replace(";", ""))) {
                          let filereDocSet = item
                            .getAttribute("FileRef")
                            .split("#")[1];
                          const FileLeafRef = item
                            .getAttribute("FileLeafRef")
                            .split("#")[1];
                          const newFileRefUrl = filereDocSet.substr(
                            0,
                            filereDocSet.indexOf("/" + FileLeafRef)
                          );

                          const objElementIndex = ctl.results.findIndex(
                            (el) =>
                              el.FileRef == newFileRefUrl &&
                              el.County == county.replace(";", "")
                          );

                          //Create a copy of the state
                          let newArray = [...ctl.results];
                          let newFilesArray = [
                            ...newArray[objElementIndex].Files,
                          ];
                          newFilesArray.push({
                            ChangeItem: item.getAttribute("BaseName"),
                            ChangeURL:
                              "/" + item.getAttribute("FileRef").split("#")[1],
                          });
                          //Update one Value
                          newArray[objElementIndex] = {
                            ...newArray[objElementIndex],
                            Files: newFilesArray,
                          };
                          //SetState
                          //ctl.results = ctl.mergeResults(newArray);
                          ctl.results = newArray;
                        }
                      });
                  } else {
                    let filereDocSet = item
                      .getAttribute("FileRef")
                      .split("#")[1];
                    const FileLeafRef = item
                      .getAttribute("FileLeafRef")
                      .split("#")[1];
                    const newFileRefUrl = filereDocSet.substr(
                      0,
                      filereDocSet.indexOf("/" + FileLeafRef)
                    );

                    const objElementIndex = ctl.results.findIndex(
                      (el) => el.FileRef == newFileRefUrl
                    );

                    //Create a copy of the state
                    let newArray = [...ctl.results];
                    let newFilesArray = [...newArray[objElementIndex].Files];
                    newFilesArray.push({
                      ChangeItem: item.getAttribute("BaseName"),
                      ChangeURL:
                        "/" + item.getAttribute("FileRef").split("#")[1],
                    });
                    //Update one Value
                    newArray[objElementIndex] = {
                      ...newArray[objElementIndex],
                      Files: newFilesArray,
                    };
                    //SetState
                    //ctl.results = ctl.mergeResults(newArray);
                    ctl.results = newArray;
                  }
                }
              });
              ctl.results = ctl.mergeResults([...ctl.results]);
            });
        }
      } catch (e) {
        console.log(e);
      }
    },
    //This method will merge the results from the List Route Changes and our Staging Route Changes List,
    //
    mergeResults(results) {
      console.log(results);
      let newResults = [];
      //After getting the search from both sources we iterate through each item
      results.forEach((item) => {
        const NewResultItem = {
          County: item.County,
          Name: item.Name,
          "Road Type": item["Road Type"],
          Files: [],
        };
        //First we get all the duplicates
        const subResults = results.filter(
          (x) =>
            x.County == item.County &&
            x.Name == item.Name &&
            x["Road Type"] == item["Road Type"]
        );
        if (subResults.length > 1) {
          //We check if the item that we are checking is in the NewREsults array if its already there it means that it was already processed and is no longer needed in tehe
          // newresults []

          let IdCheck = -1;

          newResults.forEach((checkItem) => {
            if (
              checkItem.County == item.County &&
              checkItem.Name == item.Name &&
              checkItem["Road Type"] == item["Road Type"]
            ) {
              IdCheck = 1;
            }
          });

          if (IdCheck == -1) {
            //we have to iterate through each sub result to get the files and then assign those files to the newResultItem
            subResults.forEach((subItem) => {
              //console.log(subItem);
              subItem.Files.forEach((subFile) => {
                NewResultItem.Files.push({
                  ChangeItem: subFile.ChangeItem,
                  ChangeURL: subFile.ChangeURL,
                });
              });
            });
            newResults.push(NewResultItem);
          }
        } else {
          NewResultItem.Files = [...item.Files]; //Copy the entire three and create a new one and assing it to NewResult.Files
          newResults.push(NewResultItem);
        }
      });
      newResults = newResults.sort((a, b) => {
        if (a.Name < b.Name) {
          return -1;
        }
        if (a.Name > b.Name) {
          return 1;
        }
        return 0;
      });
      console.log(newResults);
      return newResults;
    },
  },

  watch: {
    searchObj: function (val) {
      this.getInitialState(val.roadType, val.keyword);
    },
  },

  created() {
    this.getInitialState();
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #2c3e50;
  margin-top: 60px;
  width: 850px !important;
}
button {
  width: 80px !important;
}
</style>
